class InfoPanelElement extends HTMLElement {
  connectedCallback() {
    this.addEventListener("click", this);
  }

  handleEvent(e) {
    if (e.type === "click") {
      if (e.target.tagName === "BUTTON") {
        this.remove();
      }
    }
  }
}

customElements.define("info-panel", InfoPanelElement);
